import {SIZE_CHOICES, COLOR_CHOICES, MDCButtonComponent} from './button.component';

class IconButtonComponent extends MDCButtonComponent {
  constructor($element) {
    'ngInject';
    super($element);
    this.size = SIZE_CHOICES.ICON;

    this.light = false;
    this.pixelSize = 32;
    this.thickBorder = true;
  }

  getButtonColor() {
    return (this.light? COLOR_CHOICES.WHITEGREEN : COLOR_CHOICES.GREEN);
  }
}

const config = MDCButtonComponent.componentConfig(IconButtonComponent);

const mod = angular.module('common.materialComponents.iconButton', [
])

.component('iconButton', config);

export default mod.name;



// WEBPACK FOOTER //
// ./src/common/material-components/buttons/icon-button.component.js